module.exports = __webpack_public_path__ + "img/db888e5efb1b52cb63c7e9a8c78a93d2.jpg";